/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IProofPointsViewProps } from './proof-points';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
export default (props: IProofPointsViewProps) => {
    const { proofPoints, proofPointsContainer, proofPointsNode } = props;
    return (
        <Module {...proofPoints}>
            <Node {...proofPointsContainer} className={proofPointsContainer?.className ?? ''}>
                {proofPointsNode}
            </Node>
        </Module>
    );
};
